
import {pickBy} from 'lodash-es'
import router from 'router'

const mixin = {
  state() {
    return {
      routeParams: {},
    }
  },

  mutations: {
    route(state, value) {
      state.routeParams = {...state.routeParams, ...pickBy(router.currentRoute.params, v => v != null), ...value.params}

      const route = {
        name: value.name != null ? value.name : router.currentRoute.name,
        params: state.routeParams,
      }

      if(route.name != null) {
        const matched = router.resolve(route).route.matched
        if(0 < matched.length) {
          route.params =
            matched[0].regex.keys.map(v => v.name)
            .reduce((acc, key) => ({...acc, [key]: state.routeParams[key]}), {})
        }
      }

      if(route.name !== router.currentRoute.name || Object.values(route.params).every(v => v != null)) {
        ;( // eslint-disable-line no-extra-semi
          Object.values(router.currentRoute.params).some(v => v == null)
            ? router.replace(route)
            : router.push(route)
        )
        .catch(e => {
          // 同じURLに遷移しようとした時にvue-routerがpromiseのrejectを発生するのを抑える
          if(e.name != 'NavigationDuplicated') {
            throw e
          }
        })
      }
    },
  },
}

export default mixin
